// extracted by mini-css-extract-plugin
export default {"container":"key_contacts_container__S0Uc9","avatar":"key_contacts_avatar__hmO1K","email":"key_contacts_email__CPHjZ","imageWidth":"key_contacts_imageWidth__fG2Kg"};